module.exports = __webpack_public_path__ + "static/logo-set-6ff3f843d50ae9b3d77f9c5e0c911f61.png";